import React, { Component } from 'react';
import {Modal, Button, Spinner} from "react-bootstrap";
import P5Cell from "./P5Cell/P5Cell";
const ThreeCell = React.lazy(() => import("./ThreeCell/ThreeCell"));

class MintSuccessModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projectTokens: this.props.projectTokens,
      script: this.props.script,
    }
  }

  updateAndNotify = () => {
      if(this.props.mostRecentMintEvent) {
        // console.log("MintSuccessModal - updateAndNotify - mostRecentMintEvent: ", this.props.mostRecentMintEvent)
        // console.log("MintSuccessModal - updateAndNotify - projectTokens[mostRecentMintEvent.returnValues.editionId-1]: ", this.props.projectTokens[this.props.mostRecentMintEvent.returnValues.editionId-1])
      }
      //console.log("MintSuccessModal - updateAndNotify - script: ", this.props.script)
      this.setState({
        projectTokens: this.props.projectTokens,
        script: this.props.script,
      });
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    //console.logs.length = 0;
    if (prevProps.projectTokens !== this.props.projectTokens || prevProps.mostRecentMintEvent !== this.props.mostRecentMintEvent || prevProps.script !== this.props.script || prevProps.scriptType !== this.props.scriptType) {
      this.updateAndNotify();
    }
  }

  render() {
    const {
      platform, contract,
      isMintSuccessOpen, closeMintSuccessModal,
      projects, projectId, mostRecentMintEvent } = this.props;

    const {projectTokens, script} = this.state;

    const search = window.location.search || '';
    const editionLink = (editionId) => `${search}#/${projectId}/${editionId}`;

    return(
      <Modal aria-labelledby="contained-modal-title-vcenter" centered
            size="lg" show={isMintSuccessOpen} onHide={closeMintSuccessModal}>
              <Modal.Header closeButton>
                <Modal.Title className="font-display">{(mostRecentMintEvent) ? "congratulations!" : ""}</Modal.Title>
              </Modal.Header>
              <Modal.Body>

              <div className="col-lg-12 d-flex text-center">
                <div className="content mr-auto ml-auto">
                {
                  (projects[projectId-1] && mostRecentMintEvent) ? ( // Check that the project is loaded, then check if its available
                    <>
                    <div className="mint-success-banner">
                      <h3>
                      {`you now own`}
                      </h3>
                      <h3>
                      {`${ projects[projectId-1].name } # ${ mostRecentMintEvent.returnValues.editionId}`}
                      </h3>
                    </div>

                    {(projectTokens[mostRecentMintEvent.returnValues.editionId-1] && script && projects[projectId-1].scriptType === "p5js") ? (
                    <>
                    <p></p>
                    <table className="miniGridTable"><tr><td>
                    <P5Cell
                      key={`${projectTokens[mostRecentMintEvent.returnValues.editionId-1].tokenId}-success`}
                      square="4"
                      indexValue="0"
                      token={projectTokens[mostRecentMintEvent.returnValues.editionId-1]}
                      selected={false}
                      script={script}
                      //setSelectedEditionMetadata={setSelectedEditionMetadata}
                      handleClick={() => { window.open(editionLink(mostRecentMintEvent.returnValues.editionId))} }
                    />
                    </td></tr></table>
                    </>
                  ) : (projectTokens[mostRecentMintEvent.returnValues.editionId-1] && script && ["threejs","vanillajs","glsl"].includes(projects[projectId-1].scriptType)) ? (
                    <>
                    <p></p>
                    <table className="miniGridTable"><tr><td>
                    <React.Suspense fallback={<div/>}>
                    <ThreeCell
                      key={`${projectTokens[mostRecentMintEvent.returnValues.editionId-1].tokenId}-success`}
                      square="4"
                      indexValue="0"
                      token={projectTokens[mostRecentMintEvent.returnValues.editionId-1]}
                      selected={false}
                      script={script}
                      scriptType={projects[projectId-1].scriptType}
                      handleClick={() => { window.open(editionLink(mostRecentMintEvent.returnValues.editionId))} }
                    />
                    </React.Suspense>
                    </td></tr></table>
                    </>
                  ) : (
                    <>
                    <p></p>
                    <div className="text-center">Loading mint preview...</div>
                    <div className="text-center"><Spinner animation="grow" /></div>
                    </>
                  )}
                    </>
                  ) : ("")
                }
                <p></p>
                </div>
              </div>
              </Modal.Body>
              <Modal.Footer>
              {(contract && contract.options) ? (
                <>
                <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${contract.options.address}`)}>etherscan</Button>
                </>
              ) : ("")}
                <Button variant="secondary btn-sm" className="font-display" onClick={closeMintSuccessModal}>
                  close
                </Button>
              </Modal.Footer>
            </Modal>
    );
  }
}

export default MintSuccessModal;
